import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import ConfidenceAppend from "nlib/common/ConfidenceAppend";
import React, { useState } from "react";
import SelectClassInput from "nlib/common/SelectClassInput";
import VendorValidation from "nlib/common/VendorValidation";

const SelectClass = (props) => {
  const {
    value,
    audit,
    vendorId,
    disabled,
    placeholder,
    transactionId,
    showVendorValidation,
    onChange,
    ...restProps
  } = props;

  const { uiTexts } = useSelector(getTextsData);

  const [inputOpened, setInputOpened] = useState(false);

  const [validationOpened, setValidationOpened] = useState(false);

  return (
    <VendorValidation
      skip={!showVendorValidation || disabled}
      opened={validationOpened && !inputOpened}
      vendorId={vendorId}
      listName="classes"
      name="class"
      entityValue={value}
      confidence={audit ? null : value?.confidence}
      setOpened={setValidationOpened}
      updateTransaction={onChange}>
      {({ iconComponent, showWarning, showCriticalWarning }) => {
        return (
          <ConfidenceAppend
            icon={iconComponent}
            confidence={audit ? null : value?.confidence}>
            <SelectClassInput
              disabled={disabled}
              value={value}
              invalid={!!(value?.name && !value?.id)}
              valid={!!(value?.name && value?.id)}
              warning={showWarning}
              border={(showWarning || showCriticalWarning) && "warning"}
              opened={inputOpened}
              placeholder={placeholder || (!value?.name && disabled ? uiTexts.noClass : undefined)}
              setOpened={setInputOpened}
              onChange={onChange}
              {...restProps} />
          </ConfidenceAppend>
        );
      }}
    </VendorValidation>

  );
};

export default React.memo(SelectClass);
